<template>
    <div class="pr-6 py-4 pl-16">
        <app-table
            ref="table"
            :headers="collection.headers"
            :request-items="collection.request"
            :default-headers="collection.default_headers"
            :cast="cast"
            sticky-expanded-item
            :hide-actions="hideActions"
            lazy-load
            :no-data-message="noDataMessage"
            :preset-filters="presetFilters"
            :hide-top="!heading && hideActions"
            class="background rounded"
            @error="$emit('error', $event)"
        >
            <template v-if="heading" #heading>
                <div class="text-overline font-weight-bold ml-4 mb-2">
                    {{ heading }}
                </div>
            </template>
            <template #actions>
                <slot name="actions" />
            </template>
            <template v-for="slot in itemSlots" #[slot]="data">
                <slot :name="slot" v-bind="data" />
            </template>
        </app-table>
    </div>
</template>

<script>
import table from '@/mixins/table';
import { Collection } from '@/models';

export default {
    name: 'AppTablePanel',
    mixins: [table],
    props: {
        heading: {
            type: String,
            default: null
        },
        collection: {
            type: Collection,
            default: null
        },
        cast: {
            type: Object,
            default: null
        },
        hideActions: {
            type: Boolean,
            default: false
        },
        noDataMessage: {
            type: String,
            default: null
        },
        presetFilters: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        itemSlots() {
            return this._.keys(this._.pickBy(this.$scopedSlots, (v, k) => k.startsWith('item.')));
        }
    }
};
</script>
